import { httpClient } from '@shared/js/api/httpClient';

const getInitialState = () => ({
	isLoading:           false,
	follows:             [],
	followables:         [],
	followInProgressFor: [],
});

export const mutations = {
	SET_FOLLOWS:                'setFollows',
	SET_IS_LOADING:             'setIsLoading',
	SET_FOLLOWABLES:            'setFollowables',
	SET_FOLLOW_IN_PROGRESS_FOR: 'setFollowInProgressFor',
};

export const actions = {
	LOAD_FOLLOWS:     'loadFollows',
	LOAD_FOLLOWABLES: 'loadFollowables',
	FOLLOW:           'follow',
	UNFOLLOW:         'unfollow',
};

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		[mutations.SET_FOLLOWS](state, follows) {
			state.follows = follows;
		},
		[mutations.SET_IS_LOADING](state, isLoading) {
			state.isLoading = isLoading;
		},
		[mutations.SET_FOLLOWABLES](state, followables) {
			state.followables = followables;
		},
		[mutations.SET_FOLLOW_IN_PROGRESS_FOR](state, followInProgressFor) {
			state.followInProgressFor = followInProgressFor;
		},
	},
	actions: {
		async [actions.LOAD_FOLLOWS]({ commit }) {
			try {
				commit(mutations.SET_IS_LOADING, true);
				const response = await httpClient.getFollows();
				commit(mutations.SET_FOLLOWS, response.data);
			} catch (error) {
				window.toast.error(window.$I18n.trans('errors.500.title'));
			} finally {
				commit(mutations.SET_IS_LOADING, false);
			}
		},
		async [actions.LOAD_FOLLOWABLES]({ commit }) {
			try {
				const response = await httpClient.getFollowables();
				const followables = (response.data || []).map((item) => {
					return {
						context: {
							id:   item.contextId,
							name: item.contextName,
						},
						contextable: {
							id:       item.contextableId,
							imageUrl: item.imageUrl,
							name:     item.name,
						},
					};
				});
				commit(mutations.SET_FOLLOWABLES, followables);
			} catch (error) {
				window.toast.error(window.$I18n.trans('errors.500.title'));
			}
		},
		async [actions.FOLLOW]({ state, commit }, item) {
			try {
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, [...state.followInProgressFor, item]);
				await httpClient.follow(item.context.id, item.contextable.id);
				commit(mutations.SET_FOLLOWS, [...state.follows, item]);
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, state.followInProgressFor.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
			} catch (error) {
				window.toast.error(window.$I18n.trans('errors.500.title'));
			}
		},
		async [actions.UNFOLLOW]({ state, commit }, item) {
			try {
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, [...state.followInProgressFor, item]);
				await httpClient.unfollow(item.context.id, item.contextable.id);
				commit(mutations.SET_FOLLOWS, state.follows.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
				commit(mutations.SET_FOLLOW_IN_PROGRESS_FOR, state.followInProgressFor.filter((currentItem) => !(currentItem.context.id === item.context.id && currentItem.contextable.id === item.contextable.id)));
			} catch (error) {
				window.toast.error(window.$I18n.trans('errors.500.title'));
			}
		},
	},
	getters: {
		follows:             state => state.follows,
		isLoading:           state => state.isLoading,
		followables:         state => state.followables,
		followInProgressFor: state => state.followInProgressFor,
	},
};
